import { CoreApplicationContext } from '@eventbrite/context-gen';
import { setLanguage } from '@eventbrite/i18n';
import { configureStore } from '@eventbrite/redux-configure-store';
import React, { PureComponent } from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import ConnectedPage from './containers/ConnectedPage';
import { ServerData } from './models';
import {
    CheckoutBankredirectState,
    getInitialState,
    reducer,
} from './reducers';

export default class CheckoutWidgetBankRedirectApp extends PureComponent<
    ServerData & CoreApplicationContext
> {
    private _store: Store<CheckoutBankredirectState>;

    constructor(props: ServerData & CoreApplicationContext) {
        super(props);

        setLanguage(props.env.localeInfo.locale);

        // creates a store w/ Redux logging defaulted in development environment
        // also adds `redux-thunk` middleware by default for async actions
        this._store = configureStore({
            reducer,
            initialState: getInitialState(props),
        });

        setLanguage(props.env.localeInfo.locale);
    }

    render() {
        return (
            <Provider store={this._store}>
                <ConnectedPage {...this.props} />
            </Provider>
        );
    }
}
